import type { AgentIdentity, TrustStatus } from '../identity/agent-identity.js';
import type { AgentProfile } from '../core/contracts/index.js';

export interface RegisteredAgentEntry {
  identity: AgentIdentity;
  profile: AgentProfile;
  lastSeenAt: number;
}

export class AgentRegistry {
  private agents = new Map<string, RegisteredAgentEntry>();

  registerAgent(identity: AgentIdentity, profile: AgentProfile): void {
    if (identity.status === 'revoked') {
      throw new Error(`Cannot register revoked agent ${identity.id}`);
    }
    this.agents.set(identity.id, {
      identity,
      profile,
      lastSeenAt: Date.now(),
    });
  }

  getAgent(agentId: string): RegisteredAgentEntry | undefined {
    return this.agents.get(agentId);
  }

  updateTrustStatus(agentId: string, status: TrustStatus): void {
    const entry = this.agents.get(agentId);
    if (!entry) throw new Error(`Agent ${agentId} not found`);
    entry.identity.trustStatus = status;
    if (status === 'revoked') {
      entry.identity.status = 'revoked';
    } else if (status === 'suspended') {
      entry.identity.status = 'suspended';
    }
  }

  listAgents(tenantId?: string): AgentProfile[] {
    const list: AgentProfile[] = [];
    for (const entry of this.agents.values()) {
      if (entry.identity.status === 'revoked' || entry.identity.status === 'suspended') continue;
      if (tenantId && entry.identity.tenantId !== tenantId) continue;
      list.push(entry.profile);
    }
    return list;
  }
}
